var _circle, _circle2, _ellipse, _ellipse2, _path, _circle3, _circle4, _circle5, _circle6, _circle7, _rect, _rect2, _rect3, _g, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageMaintanace(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 338,
    viewBox: "0 0 559 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 236.399,
    cy: 189.278,
    r: 126.286,
    fill: "#FB7C51",
    fillOpacity: 0.37
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.399,
    cy: 189.278,
    r: 126.286,
    stroke: "#FB7C51"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.296,
    cy: 157.921,
    rx: 9.2893,
    ry: 17.4171,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.998,
    cy: 157.921,
    rx: 9.2893,
    ry: 17.4171,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.2 238.042C238.229 224.495 287.192 205.529 298.804 238.042",
    stroke: "white",
    strokeWidth: 4.29608
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.647,
    cy: 181.157,
    r: 124.854,
    stroke: "#FB7C51",
    strokeWidth: 2.86405
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.891,
    cy: 37.2074,
    r: 12.7113,
    fill: "#FB7C51"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 387.677,
    cy: 9.32548,
    r: 8.74344,
    fill: "#FB7C51"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 54.3807,
    cy: 198.021,
    r: 8.74344,
    fill: "#FB7C51"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 429.346,
    cy: 220.322,
    r: 8.74344,
    fill: "#FB7C51"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59.4628,
    height: 9.98354,
    rx: 4.99177,
    transform: "matrix(-1 0 0 1 80.5361 37.207)",
    fill: "#FB7C51"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 440.633,
    y: 318.973,
    width: 43.1132,
    height: 7.23851,
    rx: 3.61926,
    fill: "#FB7C51"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 455.457,
    y: 330.691,
    width: 43.1132,
    height: 7.23851,
    rx: 3.61926,
    fill: "#FB7C51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.35,
    y: 98.9648,
    width: 43.1132,
    height: 7.23851,
    rx: 3.61926,
    fill: "#FB7C51"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 59.4628,
    height: 9.98354,
    rx: 4.99177,
    transform: "matrix(-1 0 0 1 60.0913 53.3711)",
    fill: "#FB7C51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMaintanace);
export default __webpack_public_path__ + "static/media/image_maintanace.10bbce7f303a221b4b9ab5afada15acb.svg";
export { ForwardRef as ReactComponent };